import React, { useMemo } from "react";
import { Checkbox, TableCell, TableHead, TableRow, TableSortLabel } from "@mui/material";
import PropTypes from "prop-types";

function EnhancedTableHead(props) {
  const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  const checkBox = useMemo(() => {
    return (
      <TableCell padding={"checkbox"} style={{ padding: "0 0 0 16px" }}>
        <Checkbox
          checked={rowCount > 0 ? numSelected === rowCount : null}
          color={"primary"}
          indeterminate={numSelected > 0 ? numSelected < rowCount : null}
          inputProps={{
            "aria-label": "select all",
          }}
          onChange={onSelectAllClick}
        />
      </TableCell>
    );
  }, [numSelected, rowCount, onSelectAllClick]);

  const checkBoxSelection = useMemo(() => {
    if (props.checkboxSelection) {
      if (typeof props.checkboxSelection === "function") {
        return props.checkboxSelection(checkBox);
      } else {
        return checkBox;
      }
    }
    return null;
  }, [checkBox, props.checkboxSelection]);

  return (
    <TableHead>
      <TableRow>
        {checkBoxSelection}
        {props.headerCells.map((headCell) => (
          <TableCell
            align={"left"}
            key={headCell.id}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
            style={{ fontWeight: 800, padding: "0 0 0 16px" }}
          >
            {headCell.sortable ? (
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
              </TableSortLabel>
            ) : (
              headCell.label
            )}
          </TableCell>
        ))}
        <TableCell /> {/** Row actions */}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
  checkboxSelection: PropTypes.func,
  headerCells: PropTypes.array.isRequired,
};

export default EnhancedTableHead;
